import { render, staticRenderFns } from "./PopUpInfo.vue?vue&type=template&id=7f89ea0e&scoped=true"
import script from "./PopUpInfo.vue?vue&type=script&lang=js"
export * from "./PopUpInfo.vue?vue&type=script&lang=js"
import style0 from "./PopUpInfo.vue?vue&type=style&index=0&id=7f89ea0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f89ea0e",
  null
  
)

export default component.exports